import { TBaseApiError } from '@/typescript/types/common.type';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InventoryService } from '@services/inventory/inventory.service';
import { LoadingService } from '@services/loading/loading.service';
import { environment } from 'environments/environment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-vehicle-details',
  templateUrl: './vehicle-details.component.html',
  styleUrls: ['./vehicle-details.component.scss'],
})
export class VehicleDetailsComponent implements OnInit {
  Object = Object;
  public slides: any[] = [];
  public vehicleInfo: any[] = [];
  public vehicleName: any;
  public loading: boolean = false;
  public location: string;
  public env = environment.forntend_url;
  public noImage: any;
  public baseUrl: string = environment.imgBaseUrl;
  public videoUrl: string = '';
  public modalRef?: BsModalRef | null;
  public modalRefconfig: object = {
    ignoreBackdropClick: true,
    class: 'modal-lg',
  };
  public productId: string = '';
  public vehicleStatus: boolean;
  public laddaLoading: boolean = false;
  public tags = {
    '1': { tagName: 'Individual' },
    '2': { tagName: 'Used' },
    '3': { tagName: 'New' },
    '4': { tagName: 'Salvage' },
  };
  public showConfirm = false;
  public deleting = false;
  public vehicleBuyStatus: 'sold' | 'unsold' = 'unsold';

  constructor(
    public inventoryService: InventoryService,
    public toastr: ToastrService,
    public loader: LoadingService,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private modalService: BsModalService
  ) {
    const id = this.activatedRoute.snapshot.paramMap.get('InventoryProductId');

    if (id) {
      this.productId = id;
    }
  }

  ngOnInit(): void {
    this.getVehicleDetails();
    this.noImage = this.env + 'assets/img/car-placeholder.png';
  }

  getVehicleDetails() {
    this.loading = true;
    let getId = this.activatedRoute.snapshot.paramMap.get('InventoryProductId');

    this.inventoryService.getvehicleInfo(getId).subscribe(
      (res) => {
        this.toastr.success(res['message']);
        this.location = res['data']['location'];
        this.vehicleInfo = res['data'];
        // console.log(this.vehicleInfo, 'this.vehicleInfo');

        this.reformatObjectStructure(this.vehicleInfo);
        // change the baseurl
        this.baseUrl =
          this.vehicleInfo?.['type'] === '1'
            ? environment.imgBaseUrl
            : environment.auctionBaseUrl;
        this.slides = [];
        this.vehicleStatus = res['data']['active'];

        // updating latest buy status
        this.vehicleBuyStatus = +res['data']['buy_status'] ? 'sold' : 'unsold';

        if (this.vehicleInfo['imageUrl'].length !== 0) {
          for (let value of this.vehicleInfo['imageUrl']) {
            this.slides.push(value['presigned_url']);
          }
        } else if (this.vehicleInfo['vehicle_images'] !== null) {
          let frontImg: string = '';
          for (let value of this.vehicleInfo['vehicle_images'][
            'parts_images'
          ]) {
            if (value['part_name'] === 'Front') {
              frontImg = this.baseUrl + value['image'];
            } else {
              this.slides.push(this.baseUrl + value['image']);
            }
          }
          this.slides = [frontImg, ...this.slides];
        } else {
          this.slides.push(this.noImage);
        }

        this.getVehicleName(this.vehicleInfo);
        this.generateVehicalOtherInfo(
          this.vehicleInfo?.['options']?.['options']
        );
        this.loading = false;
      },
      (error: HttpErrorResponse) => {
        this.loading = false;
      }
    );
  }

  getVehicleName(data: any) {
    if (data) {
      this.vehicleName =
        data['description_data']['Model Year'] +
        ' ' +
        data['description_data']['Model'] +
        ' ' +
        (data['description_data']['Vehicle Type'] ||
          data['description_data']['Vehicle type']);
    }
  }

  openTestDriveModal(template: TemplateRef<any>, urlId: string) {
    this.switch = 'testDrive';
    this.modalRef = this.modalService.show(template, this.modalRefconfig);
    this.videoUrl = 'https://www.youtube.com/embed/' + urlId;
    const container: HTMLElement | null = document.getElementById('spins-data');
    container?.setAttribute('src', this.videoUrl);
  }

  public vehicleOtherInfo: object[] = [];
  generateVehicalOtherInfo(vehicleOptions: object[]) {
    vehicleOptions?.forEach((vehicle) => {
      this.vehicleOtherInfo.push({
        [vehicle['title']]: vehicle['data'][0]['title'],
      });
    });
  }

  open360ViewModal(template: TemplateRef<any>, link360: string) {
    this.switch = '360View';
    this.modalRef = this.modalService.show(template, this.modalRefconfig);
    const container: HTMLElement | null = document.getElementById('spins-data');
    container?.setAttribute('src', link360);
  }

  public vinNumber: string = '';
  public testDriveVideoLink: string = '';
  reformatObjectStructure(data) {
    for (const property in data['description_data']) {
      if (property === 'VIN Number') {
        this.vinNumber = data['description_data'][property];
      }

      if (property === 'test_drive_video') {
        this.testDriveVideoLink = data['description_data'][property];
        delete data['description_data']['test_drive_video'];
        data['description_data']['Test Drive Video'] = this.testDriveVideoLink;
      }

      if (property === 'vehicle_360_link') {
        delete data['description_data']['vehicle_360_link'];
        data['description_data']['Vehicle 360 Link'] =
          'https://spins.spincar.com/universalmotoragencies/' +
          this.vinNumber.toLowerCase();
      }
    }
  }

  public switch: '360View' | 'testDrive' | '' = '';

  updateVehicleStatus(productId: string, status: boolean) {
    this.laddaLoading = true;

    const payload = {
      active_status: status,
    };

    this.inventoryService
      .vehicleActiveStatusUpdate(productId, payload)
      .subscribe((res) => {
        if (res['success']) {
          this.vehicleStatus = !this.vehicleStatus;
        }

        this.laddaLoading = false;
      });
  }

  toggleSold() {
    this.showConfirm = !this.showConfirm;
  }

  onConfirmed(): void {
    // wasAuto === true means the timer ran out, not a manual click
    this.deleting = true;
    this.inventoryService.productSold(this.productId).subscribe(
      (res) => {
        if (res?.success) {
          this.toastr.success(res?.message, 'Success');
          this.showConfirm = false;
          this.deleting = false;
          this.getVehicleDetails();
        }
      },
      (error: TBaseApiError) => {
        this.toastr.error(
          error?.error?.errors ?? 'Something went wrong',
          'Error'
        );
        this.showConfirm = false;
        this.deleting = false;
      }
    );
    // ... perform the action
  }

  onCancelled(): void {
    this.showConfirm = false;
  }
}
